import _defineProperty from "@babel/runtime/helpers/defineProperty";
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
import { Box, Popover, PopoverArrow, PopoverBody, PopoverContent, PopoverTrigger as OrigPopoverTrigger } from '@chakra-ui/react';
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
export var PopoverTrigger = OrigPopoverTrigger;
var popoverStyleProps = {
  _focus: {
    boxShadow: '0 2px 8px 0px var(--chakra-colors-lightGrey1)'
  },
  _focusVisible: {
    outline: 'none'
  },
  inset: '10px auto auto 0px',
  boxShadow: '0 2px 8px 0px var(--chakra-colors-lightGrey1)',
  border: '1px solid var(--chakra-colors-lightGrey4)',
  padding: '24px',
  borderRadius: '3px',
  width: 'fit-content'
};
var popoverArrowStyles = {
  boxShadow: '-2px 2px 1px 0 var(--chakra-colors-lightGrey4)!important',
  width: '200% !important;',
  height: '200% !important;',
  top: '-4px !important;',
  left: '-4px !important;',
  transform: 'rotate(135deg) !important'
};
export default function PopoverComponent(_ref) {
  var triggerItem = _ref.triggerItem,
    children = _ref.children,
    styles = _ref.styles;
  var hasArrowStyles = styles === null || styles === void 0 ? void 0 : styles.arrowStyles;
  var customPopoverArrowStyles = hasArrowStyles ? _objectSpread(_objectSpread({}, popoverArrowStyles), hasArrowStyles) : _objectSpread({}, popoverArrowStyles);
  return _jsxs(Popover, {
    closeOnBlur: true,
    children: [_jsx(PopoverTrigger, {
      children: _jsx(Box, {
        _focusVisible: {
          outline: 'none'
        },
        children: triggerItem
      })
    }), _jsxs(PopoverContent, _objectSpread(_objectSpread({}, popoverStyleProps), {}, {
      children: [_jsx(PopoverArrow, _objectSpread({}, customPopoverArrowStyles)), _jsx(PopoverBody, {
        p: "0",
        children: children
      })]
    }))]
  });
}